var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-page"},[_c('RwvArticleList',{attrs:{"favorited":_vm.favorited,"items-per-page":5}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }